const haveItem = (item, list) => {
    return list.indexOf(item);
};

const removeItem = (item, list) => {
    const index = haveItem(item, list);
    if (index !== -1) {
        list.splice(index, 1)
    }
};

const addItem = (item, list) => {
    list.push(item)
};


export {
    haveItem,
    removeItem,
    addItem
}